import { useStaticQuery, graphql } from 'gatsby'

export const useFormHomeQuery = () => {
const { wpPage } = useStaticQuery(
    graphql`
  query FormHomeQuery{
    wpPage(slug: { eq: "home" }) {
      home {
        formHeading
    }
    }
  }
  `
);
return wpPage.home;
}